module.exports = __webpack_public_path__ + "static/media/workingmemory-words-1.12d2d91b.mp3";